import { render, staticRenderFns } from "./SopWorkTaskBoard.vue?vue&type=template&id=4198d870&"
import script from "./SopWorkTaskBoard.vue?vue&type=script&lang=js&"
export * from "./SopWorkTaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./SopWorkTaskBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4198d870')) {
      api.createRecord('4198d870', component.options)
    } else {
      api.reload('4198d870', component.options)
    }
    module.hot.accept("./SopWorkTaskBoard.vue?vue&type=template&id=4198d870&", function () {
      api.rerender('4198d870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/SopWorkTaskBoard.vue"
export default component.exports